import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Link } from "@mui/icons-material"
import { percentageFormatter, numberFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"

class Factor extends Component {
  static propTypes = {
    factor: PropTypes.object.isRequired,
    otherLabel: PropTypes.string.isRequired,
    max: PropTypes.number.isRequired,
    openFactorProfile: PropTypes.func,
    noPercent: PropTypes.bool,
  }

  onClick = () => {
    const { factor, openFactorProfile } = this.props
    openFactorProfile(factor.id)
  }

  render() {
    const { max, factor, otherLabel, noPercent, openFactorProfile } = this.props
    const chartWidth = Math.abs(factor.value) / max * 100

    const link = factor.id === "other" || getFactorDisabled(factor.category) || !openFactorProfile
      ? <span className="item-label-container">{factor.label || otherLabel}</span>
      : <a onClick={this.onClick}><span className="item-label-container">{factor.label || otherLabel}</span><Link className="icon" /></a>

    return <div className={classNames("attribution-item-wrapper", factor.className)}>
      <div className="attribution-item-label" title={factor.label || otherLabel}>
        {link}
      </div>
      <div className="attribution-chart-bar">
        <div className="bar" style={{ width: `${chartWidth}%` }} />
      </div>
      <div className={classNames("attribution-chart-value", { percent: !noPercent })}>
        {noPercent ? numberFormatter(factor.value) : percentageFormatter(factor.value)}
      </div>
    </div>
  }
}

export default Factor
